﻿{
  "community": {
    "name": "Comunidade",
    "shortDescription": "Conta única com atividades gratuitas",
    "features": [
      "Encontre e compartilhe atividades",
      "Armazenamento ilimitado de atividades na nuvem",
      "Acesso a Atividades Premium"
    ],
    "price": "Grátis",
    "termName": "Vida útil"
  },
  "personal": {
    "name": "Pessoal",
    "shortDescription": "Conta única com atividades personalizadas",
    "features": [
      "Crie e edite atividades online",
      "Inclui lista de reprodução pessoal",
      "Acesse atividades em qualquer lugar"
    ]
  },
  "professional": {
    "name": "Profissional",
    "shortDescription": "Conta única com múltiplos alunos",
    "features": [
      "Gerencie as tarefas dos alunos",
      "Monitore o progresso dos alunos",
      "Colabore com os membros da equipe"
    ]
  },
  "organization": {
    "name": "Instituição",
    "shortDescription": "Contas múltiplas com múltiplos alunos",
    "features": [
      "Gerenciamento do professor",
      "Relatório em nível institucional",
      "Configurações de segurança da empresa"
    ],
    "price": "Contate-nos",
    "termName": "Planos de 1-5 anos"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Pré-visualização do editor para área de trabalho",
    "note": "Experimente <1>$t(common:action.free)</1> por 30 dias!",
    "price": "Grátis",
    "termName": "Teste de 30 dias",
    "footerNote": "1 instalação"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Editor completo para área de trabalho",
    "note": "",
    "termName": "Compra Única",
    "footerNote": "2 instalações por usuário"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Licenças múltiplas para instituições",
    "note": "",
    "price": "Contate-nos",
    "termName": "Descontos por volume",
    "footerNote": "2 instalações por usuário"
  }
}
